/*
 * Copyright (c) 2022. Slimme Infrasoftware B.V. Apeldoorn /
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden
 * volgens de voorwaarden die zijn vastgelegd in de overeenkomst
 * tussen ATR en Slimme Infrasoftware B.V. en de onderliggende
 * overeenkomsten tussen Slimme Infrasoftware B.V en
 * Spin in het Web B.V.
 */

/*
* functie.ts
* 8-3-2021 - Jelmer Jellema - Spin in het Web B.V.
* Model voor functies
*/

import {Basemodel, ModelField, ModelRelation} from './basemodel';
import {FunctieExact} from './functie_exact';

export class Functie extends Basemodel {
  static table= 'functie';
  static defaultOrder = ['naam'];


  @ModelField() override id: number = null;
  @ModelField() naam: string;
  @ModelField() kleur: string = '#000000';
  @ModelField() opmerkingen: string;

  @ModelRelation({
    model: FunctieExact}) functie_exact: FunctieExact[];
}
